'use client'

import { useContext, createContext } from 'react'

import defaultContextValue from './defaultContextValue'
import type { ListingSearchContextValue } from './types'

const ListingSearchContext =
  createContext<ListingSearchContextValue>(defaultContextValue)

export default ListingSearchContext

export const useListingSearch = () => {
  const context = useContext(ListingSearchContext)
  if (
    context.getActiveFilterCount === defaultContextValue.getActiveFilterCount
  ) {
    throw new Error(
      'useListingSearch was called when not inside a ListingSearchProvider context'
    )
  }
  return context
}

// Returns null when called outside a ListingSearchProvider, instead of throwing.
// Use this in components that can render in both provider and non-provider contexts.
export const useOptionalListingSearch = () => {
  const context = useContext(ListingSearchContext)
  if (
    context.getActiveFilterCount === defaultContextValue.getActiveFilterCount
  ) {
    return null
  }
  return context
}
